import PropTypes from "prop-types";
import { _Background_Component } from "@/components/utils/Background/propTypes";
import { _RichContent } from "@/components/modules/RichContent/propTypes";

const _Padding = PropTypes.shape({
  display_padding: PropTypes.bool,
  padding_top: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  padding_right: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  padding_bottom: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  padding_left: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
});

const _Column = PropTypes.shape({
  column_order: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  column_width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  component: _RichContent,
  display_column_order: PropTypes.bool,
  display_column_width: PropTypes.bool,
});

const _RichColumnsComponent = PropTypes.shape({
  columns_gap: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  columns: PropTypes.arrayOf(_Column),
  padding_component: _Padding,
  ..._Background_Component,
});

export const RichColumnsPropTypes = {
  data: PropTypes.oneOfType([_RichColumnsComponent, PropTypes.any]),
};
